<template>
    <div class="card mt-2" style="margin-bottom:10px">


        <div v-if="loading" class="loading-overlay">
            
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Cargando...</span>
            </div>
            <p class="mt-3 text-primary">Cargando información...</p>
        
    </div>

        <div class="card-body seguimiento-page">
            <div class="seguimiento-head">
                <div>
                    <h6>Seguimiento de pacientes</h6>
                    <p v-if="!loading">{{ pacienteSeguimiento.length }} atenciones</p>
                </div>
                <button type="button" class="btn-refrescar" @click="loadAtencioneSeguimientoAll" aria-label="Actualizar listado">
                    <i class="fas fa-sync"></i>
                </button>
            </div>

            <div class="seguimiento-filtros">
                <div class="seguimiento-tipos">
                    <label class="tipo-busqueda">
                        <input type="radio" name="tipoBusqueda" value="paciente" v-model="tipoBusqueda">
                        <span><i class="fas fa-user"></i> Paciente</span>
                    </label>
                    <label class="tipo-busqueda">
                        <input type="radio" name="tipoBusqueda" value="doctor" v-model="tipoBusqueda">
                        <span><i class="fas fa-user-md"></i> Doctor</span>
                    </label>
                    <label class="tipo-busqueda">
                        <input type="radio" name="tipoBusqueda" value="especialidad" v-model="tipoBusqueda">
                        <span><i class="fas fa-stethoscope"></i> Especialidad</span>
                    </label>
                </div>
                <input type="text" class="seguimiento-buscar" :placeholder="'Buscar por ' + tipoBusqueda"
                    @input="programarBusqueda" />
            </div>

            <div class="seguimiento-tabla">
                <DataTable :columns="columns" :options="options" :data="pacienteSeguimiento"
                    class="table tablesorter seguimiento-table" width="100%">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Fecha/Hora</th>
                            <th>Código</th>
                            <th data-priority="1">Paciente</th>
                            <th data-priority="2">Especialidad</th>
                            <th data-priority="3">Doctor</th>
                            <th style="text-align: center!important;">Acción</th>
                        </tr>
                    </thead>


                </DataTable>
            </div>
        </div>
    </div>
</template>


<script>
/* eslint-disable */
import DataTable from 'datatables.net-vue3'
import DataTablesCore from 'datatables.net-bs5';
import 'datatables.net-responsive';
DataTable.use(DataTablesCore);


export default {
    name: "Seguimiento",
    components: {
        DataTable
    },

    data() {
        return {
            loading: true,
            isMobile: this.$isMobile,
            tokenAuth: localStorage.getItem("tokenAuth"),
            pacienteSeguimiento: [],
            columns: [
                { data: null, render: (data, type, row, meta) => meta.row + 1 },
                {
                    data: 'signos_vitales.date_at',
                    render: function (data, type) {
                        if (!data) return '';
                        const fechaHora = new Date(data);
                        if (Number.isNaN(fechaHora.getTime())) return '';
                        const fechaFormateada = fechaHora.toLocaleDateString('es-EC', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                        });
                        const horaFormateada = fechaHora.toLocaleTimeString('es-EC', {
                            hour12: false,
                            hour: '2-digit',
                            minute: '2-digit'
                        });
                        if (type && type !== 'display') return `${fechaFormateada} ${horaFormateada}`;
                        return `<div class="seguimiento-fecha"><span>${fechaFormateada}</span><small>${horaFormateada}</small></div>`;
                    }
                },
                { data: 'codigo_consulta' },
                {
                    data: null,
                    render: (data, type) => {
                        const nombre = data.nombres_pacientes || '';
                        if (type && type !== 'display') return nombre;
                        const cedula = data.cedula || '';
                        return `
                            <div class="seguimiento-persona">
                                <span class="seguimiento-nombre">${nombre}</span>
                                <span class="seguimiento-cedula">${cedula}</span>
                            </div>
                        `;
                    }
                },
                { data: 'name_especialidad' },
                { data: 'doctor' },
                {
                    data: null,
                    render: (data, type, row) => {
                        const dataObject = encodeURIComponent(JSON.stringify(row));
                        const isAdmin = this.userRole === 'administrador';
                        return `
                            <div class="d-flex justify-content-center align-items-center gap-2 flex-wrap">
                                <button class="btn btn-sm btn-revisar" data-id="${dataObject}" data-action="revisar">
                                    <i class="dataAtencion fas fa-eye me-2"></i>
                                    Revisar
                                </button>
                                ${isAdmin ? `
                                    <button class="btn btn-sm btn-delete" data-id="${dataObject}" data-action="delete">
                                        <i class="dataAtencion fas fa-trash me-2"></i>
                                        Eliminar
                                    </button>
                                ` : ''}
                            </div>
                        `;
                    }
                }
            ],
            options: {
                searching: false,
                responsive: true,
                autoWidth: false,
                lengthChange: false,
                ordering: false,
                columnDefs: [
                    { responsivePriority: 1, targets: 0 },
                    { responsivePriority: 2, targets: 4 }
                ],

                pageLength: 20,
                language: {
                    search: "Buscar:",
                    sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                    sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
                    searchPlaceholder: "Ingrese algún dato",
                    zeroRecords: "Lo sentimos, no se encontraron resultados",
                    processing: "Buscando. Espere por favor...",
                    sLengthMenu: "Mostrar _MENU_ registros",
                    oPaginate: {
                        sFirst: "Primero",
                        sLast: "Último",
                        sNext: "Siguiente",
                        sPrevious: "Anterior"
                    }
                }
            },
            tipoBusqueda: 'paciente',
            busquedaTimer: null,
            cargaId: 0,
        };
    },
    computed: {
        userRole() {
            const encryptedRole = localStorage.getItem("aut");
            if (encryptedRole && this.$encryptBackoffice && this.$encryptBackoffice.decrypt) {
                return this.$encryptBackoffice.decrypt(encryptedRole);
            }
            return null;
        }
    },
    watch: {
        tipoBusqueda() {
            const texto = String(this.textoPendiente || '').trim();
            clearTimeout(this.busquedaTimer);
            if (this.normalizar(texto).length < 2) return;
            this.loadAtencioneSeguimiento(texto);
        }
    },

    activated() { },
    mounted() {


        if (this.isMobile) {
            this.$eventBus.emit("activeShowMenu");
        }

        this.loadAtencioneSeguimientoAll()

        // Escuchar clics en los botones de "Atender"
        document.addEventListener("click", this.ClickEv);

    },

    beforeUnmount() {
        clearTimeout(this.busquedaTimer);
        document.removeEventListener("click", this.ClickEv);
    },

    methods: {

        loadAtencioneSeguimientoAll() {

            const cargaId = ++this.cargaId;
            this.loading = true

            this.$https.post('/evaluacion/getLoadAtencionesOK', {}, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.tokenAuth,
                }
            }).then(response => {

                if (cargaId !== this.cargaId) return;

                if (response.data.code === 200) {
                    this.loading = false
                    this.pacienteSeguimiento = response.data.datos; // Devuelve los datos
                } else {
                    this.loading = false
                    this.pacienteSeguimiento = []
                }
            }).catch(error => {
                if (cargaId !== this.cargaId) return;
                this.loading = false
                if (error?.response?.status === 400) {
                    this.$swal.fire({
                        title: "Ocurrió algo!",
                        html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">${error.response.data.message}</p>`,
                        icon: "warning",
                        width: "400px",
                        customClass: {
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-secondary ml-1",
                        },
                        buttonsStyling: false,
                    });
                }

                if (error?.response?.status === 401) {
                    this.showSessionExpiredAlert();
                }
                throw error; // Relanza el error para manejarlo en el componente
            });
        },

        ClickEv(event) {

            // Función auxiliar para obtener los datos del botón
            const getButtonData = (button) => {
                const dataString = button.getAttribute("data-id");
                const actionType = button.getAttribute("data-action");
                try {
                    const data = JSON.parse(decodeURIComponent(dataString)); // Decodificar y parsear JSON
                    return { data, actionType };
                } catch (e) {
                    console.error("Error al parsear el JSON:", e);
                    return null;
                }
            };

            // Verificar si el clic fue en un botón de "Atender"
            const atenderButton = event.target.closest(".btn-revisar");
            if (atenderButton) {
                const buttonData = getButtonData(atenderButton);
                if (buttonData && buttonData.actionType === "revisar") {
                    const { data } = buttonData;

                    // Navegar a la ruta de atención
                    this.$router.push({
                        name: 'detalleEvaluar',
                        query: {
                            cod_paciente: data.cod_paciente,
                            cod_consulta: data.codigo_consulta,
                            idPaciente: data.id
                        }
                    });
                }
            }

            const deleteButton = event.target.closest(".btn-delete");
            if (deleteButton) {
                const buttonData = getButtonData(deleteButton);
                if (buttonData && buttonData.actionType === "delete") {
                    const { data } = buttonData;

                    this.$swal.fire({
                        title: "¿Estás seguro?",
                        text: "Esta acción eliminará el registro de seguimiento.",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Si, eliminar",
                        cancelButtonText: "Cancelar",
                    }).then((result) => {
                        if (result.isConfirmed) {
                            console.log(data)


                            this.$https.post('/evaluacion/getDeleteConsulta', { codigo: data.codigo_consulta }, {
                                headers: {
                                    "Content-Type": "application/json",
                                    "Authorization": this.tokenAuth,
                                }
                            }).then(response => {

                                if (response.data.code === 200) {
                                    this.showSuccessToast('Registro eliminado correctamente')
                                    this.loadAtencioneSeguimientoAll()
                                }
                            }).catch(error => {
                                if (error?.response?.status === 400) {
                                    this.loading = false
                                    this.$swal.fire({
                                        title: "Ocurrió algo!",
                                        html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">${error.response.data.message}</p>`,
                                        icon: "warning",
                                        width: "400px",
                                        customClass: {
                                            confirmButton: "btn btn-primary",
                                            cancelButton: "btn btn-outline-secondary ml-1",
                                        },
                                        buttonsStyling: false,
                                    });
                                }

                                if (error?.response?.status === 401) {
                                    this.showSessionExpiredAlert();
                                }
                                throw error; // Relanza el error para manejarlo en el componente
                            });


                        }
                    })
                }
            }

        },

        programarBusqueda(event) {
            this.textoPendiente = event.target.value;
            clearTimeout(this.busquedaTimer);

            this.busquedaTimer = setTimeout(() => {
                const texto = String(this.textoPendiente || '').trim();
                if (this.normalizar(texto).length < 2) {
                    this.loadAtencioneSeguimientoAll();
                    return;
                }
                this.loadAtencioneSeguimiento(texto);
            }, 4000);
        },

        normalizar(texto) {
            return String(texto || '')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase();
        },

        loadAtencioneSeguimiento(busqueda) {
            const cargaId = ++this.cargaId;
            this.loading = true;

            this.$https.post('/evaluacion/getLoadAtencionesSearchAvanzadas', {
                tipoBusqueda: this.tipoBusqueda,
                busqueda
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.tokenAuth,
                }
            }).then(response => {
                if (cargaId !== this.cargaId) return;
                this.loading = false;
                this.pacienteSeguimiento = response.data.code === 200 ? response.data.datos : [];
            }).catch(() => {
                if (cargaId !== this.cargaId) return;
                this.pacienteSeguimiento = [];
                this.loading = false;
            });
        },

    }

}

</script>


<style>
@import "datatables.net-dt";
@import 'datatables.net-responsive-dt';

.seguimiento-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 14px;
}

.seguimiento-head h6 {
    margin: 0;
    color: #1f2a37;
    font-weight: 700;
}

.seguimiento-head p {
    margin: 2px 0 0;
    color: #6b7c8f;
    font-size: 0.78rem;
}

.btn-refrescar {
    width: 34px;
    height: 34px;
    border: 1px solid #e3eaf2;
    border-radius: 10px;
    background: #fff;
    color: #0078be;
}

.seguimiento-filtros {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 14px;
    padding: 12px;
    border: 1px solid #e6edf5;
    border-radius: 14px;
    background: #f8fbfd;
}

.seguimiento-tipos {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.tipo-busqueda {
    position: relative;
    margin: 0;
}

.tipo-busqueda input {
    position: absolute;
    opacity: 0;
    pointer-events: none;
}

.tipo-busqueda span {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    border: 1px solid #e3eaf2;
    border-radius: 999px;
    background: #fff;
    color: #4b5d6e;
    font-size: 0.78rem;
    font-weight: 700;
    cursor: pointer;
}

.tipo-busqueda input:checked + span {
    border-color: #0078be;
    background: #e8f4fc;
    color: #0078be;
}

.seguimiento-buscar {
    width: 100%;
    border: 1px solid #e3eaf2;
    border-radius: 10px;
    padding: 8px 12px;
    background: #fff;
    color: #1f2a37;
    font-size: 0.85rem;
}

.seguimiento-buscar:focus {
    outline: none;
    border-color: #0078be;
    box-shadow: 0 0 0 3px rgba(0, 120, 190, 0.12);
}

.seguimiento-tabla {
    border: 1px solid #e6edf5;
    border-radius: 14px;
    overflow: hidden;
    background: #fff;
}

.seguimiento-tabla .dataTables_wrapper {
    padding: 0 0 8px;
}

.seguimiento-tabla table.seguimiento-table {
    margin: 0 !important;
    font-size: 0.84rem;
    color: #1f2a37;
}

.seguimiento-tabla table.seguimiento-table thead th {
    padding: 12px 10px;
    border-bottom: 1px solid #e6edf5 !important;
    background: #f4f8fb;
    color: #4b5d6e;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}

.seguimiento-tabla table.seguimiento-table tbody td {
    padding: 11px 10px;
    border-bottom: 1px solid #eef2f6;
    vertical-align: middle;
}

.seguimiento-tabla table.seguimiento-table tbody tr:hover td {
    background: #f3f9fd;
}

.seguimiento-fecha {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.seguimiento-fecha small {
    color: #6b7c8f;
    font-size: 0.75rem;
}

.seguimiento-persona {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.seguimiento-nombre {
    font-weight: 700;
    line-height: 1.2;
}

.seguimiento-cedula {
    color: #6b7c8f;
    font-size: 0.75rem;
}

.seguimiento-tabla .dataTables_info,
.seguimiento-tabla .dataTables_paginate {
    padding: 8px 12px;
    color: #6b7c8f;
    font-size: 0.75rem;
}

.seguimiento-tabla .dataTables_paginate .paginate_button {
    margin: 0 2px;
    border: 1px solid #e3eaf2 !important;
    border-radius: 8px !important;
    background: #fff !important;
    color: #0078be !important;
}

.seguimiento-tabla .dataTables_paginate .paginate_button.current {
    background: #0078be !important;
    border-color: #0078be !important;
    color: #fff !important;
}

.btn-revisar {
    background-color: #c40e55;
    /* Color de fondo */
    color: white;
    /* Color del texto */
    border: none;
    /* Sin borde */
    padding: 5px 10px;
    /* Espaciado interno */
    border-radius: 5px;
    /* Bordes redondeados */
    font-size: 12px;
    /* Tamaño de fuente */
    transition: background-color 0.3s ease, color 0.3s ease;
    /* Transición suave */
}


.btn-revisar:hover {
    background-color: #0078be;
    /* Cambia el color de fondo al pasar el mouse */
    color: white !important;
    /* Cambia el color del texto al pasar el mouse */
}

.btn-delete {
    background-color: #eb1265;
    /* Color de fondo */
    color: white;
    /* Color del texto */
    border: none;
    /* Sin borde */
    padding: 5px 10px;
    /* Espaciado interno */
    border-radius: 5px;
    /* Bordes redondeados */
    font-size: 12px;
    /* Tamaño de fuente */
    transition: background-color 0.3s ease, color 0.3s ease;
    /* Transición suave */
}


.btn-delete:hover {
    background-color: red;
    /* Cambia el color de fondo o al pasar el mouse */
    color: white !important;
    /* Cambia el color del texto al pasar el mouse */
}

/* Nuevos estilos para los radio buttons */
.form-check {
    margin-bottom: 0;
}

.form-check-input {
    cursor: pointer;
}

.form-check-input:checked {
    background-color: #0078be;
    border-color: #0078be;
}

.form-check-label {
    cursor: pointer;
    font-weight: 500;
    color: #333;
}

.form-check:hover .form-check-label {
    color: #0078be;
}

/* Estilo para el input de búsqueda */
.input-group {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.input-group-text {
    background-color: #f8f9fa;
    border-right: none;
}

.form-control:focus,
.form-select:focus {
    border-color: #0078be;
    box-shadow: 0 0 0 0.2rem rgba(0, 120, 190, 0.25);
}
</style>
